<tt-page *ngIf="!!menu">
    <div *ngIf="'mobile' | mediaQuery">
        <tt-card class="col-xs-12 sp-0">
            <ng-container *ngTemplateOutlet="info"></ng-container>
            <ng-container *ngTemplateOutlet="buttons"></ng-container>
        </tt-card>
    </div>

    <div class="col-xs-12 sp-0" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-card class="col-xs-12 col-md-3 p-5" ttHeading="h_info">
            <ng-container *ngTemplateOutlet="info"></ng-container>
        </tt-card>

        <tt-card class="col-xs-12 col-md-3 p-5" ttHeading="h_functions">
            <ng-container *ngTemplateOutlet="buttons"></ng-container>
        </tt-card>
    </div>
</tt-page>

<ng-template #info>
    <ng-container *ngIf="!!menu">
        <tt-input ttLabel="sop_keyno" [ttModel]="menu.sop_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="sop_name" [ttModel]="menu.sop_name" ttReadonly></tt-input>
        <tt-select ttLabel="sop_fieldtype" [(ttModel)]="menu.sop_fieldtype" [ttData]="selectListFieldTypes" ttDataId="item_id" ttDataName="item_name" ttReadonly></tt-select>
        <tt-input ttLabel="orderby" [ttModel]="menu.orderby" ttReadonly></tt-input>
    </ng-container>
</ng-template>

<ng-template #buttons>
    <ng-container *ngIf="!!menu">
        <tt-button-goto [ttText]="'sopmenu_edit'" [ttGoto]="'sop'" [ttGotoParms]="{ sop_keyno: menu.sop_keyno }"></tt-button-goto>
        <tt-button-goto [ttText]="'sopmenu_valid'" [ttGoto]="'sopvalid'" [ttGotoParms]="{ sop_keyno: menu.sop_keyno }"></tt-button-goto>
        <tt-button-goto *ngIf="menu.sop_fieldtype === 'CL'" [ttText]="'sopmenu_sopcls'" [ttBadge]="menu.nbr_of_sopcl" [ttGoto]="'sopcls'" [ttGotoParms]="{ sop_keyno: menu.sop_keyno }"></tt-button-goto>
    </ng-container>
</ng-template>

<!--<tt-page class="col-xs-12 sp-0">
    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-3 p-5">
            <tt-page-heading class="col-xs-12 sp-0" tt-model="h_info" tt-translate="true"></tt-page-heading>
            <div class="k-hr col-xs-12 sp-0"></div>
            <tt-input class="col-xs-12 sp-0" tt-label="sop_keyno" tt-model="vm.model.menu.sop_keyno" tt-change="vm.model.menu.sop_keyno = $value" tt-readonly="true"></tt-input>
            <tt-input class="col-xs-12 sp-0" tt-label="sop_name" tt-model="vm.model.menu.sop_name" tt-change="vm.model.menu.sop_name = $value" tt-readonly="true"></tt-input>
            <tt-select class="col-xs-12 sp-0" tt-label="sop_fieldtype" tt-model="vm.model.menu.sop_fieldtype" tt-change="vm.model.menu.sop_fieldtype = $value" tt-data="vm.model.selectListFieldTypes" tt-data-id="item_id" tt-data-name="item_name" tt-readonly="true"></tt-select>
            <tt-input class="col-xs-12 sp-0" tt-label="orderby" tt-model="vm.model.menu.orderby" tt-change="vm.model.menu.orderby = $value" tt-readonly="true"></tt-input>
        </tt-card>

        <tt-card class="col-xs-12 col-md-3 p-5">
            <tt-page-heading class="col-xs-12 sp-0" tt-model="h_functions" tt-translate="true"></tt-page-heading>
            <div class="k-hr col-xs-12 sp-0"></div>
            <tt-button-goto class="col-xs-12 sp-0" tt-text="sopmenu_edit" tt-goto="sop" tt-goto-parms="{ sop_keyno: vm.model.menu.sop_keyno }" tt-text-align="left"></tt-button-goto>
            <tt-button-goto class="col-xs-12 sp-0" tt-text="sopmenu_valid" tt-goto="sopvalid" tt-goto-parms="{ sop_keyno: vm.model.menu.sop_keyno }" tt-text-align="left"></tt-button-goto>
            <div ng-if="vm.model.menu.sop_fieldtype === 'CL'">
                <tt-button-goto class="col-xs-12 sp-0" tt-text="sopmenu_sopcls" tt-badge="{{vm.model.menu.nbr_of_sopcl}}" tt-goto="sopcls" tt-goto-parms="{ sop_keyno: vm.model.menu.sop_keyno }" tt-text-align="left"></tt-button-goto>
            </div>
        </tt-card>
    </div>
</tt-page>-->
